import React from 'react';
import { ReactKeycloakProvider } from '@react-keycloak/web'
import { keycloak, keycloakInitOptions } from './keycloak'

import {
    BrowserRouter,
    Routes,
    Route
} from 'react-router-dom';

import './App.css';

import { Home } from "./components/Home";
import { OAuthCallback } from './components/OAuthCallback';

function App() {
    return (
        <ReactKeycloakProvider
            authClient={keycloak}
            initOptions={keycloakInitOptions()}
        >
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/oauth2/callback" element={<OAuthCallback />} />
                </Routes>
            </BrowserRouter>
        </ReactKeycloakProvider >
    );
}

export default App;
